import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {QueryProvider} from '@shared/queries/query-provider';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {Observable, Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {QueryModel} from '@shared/models/query-model';
import {Guid} from 'guid-typescript';
import {Configuration} from '@shared/models/configuration';
import {CreateWorkflowAction} from '../../../../workflow/store/workflow.actions';
import {getWorkflowReducerState, isWorkflowCleanedUp} from '../../../../workflow/store/workflow.selector';
import {IWorkflowState} from '../../../../workflow/store/workflow.reducer';
@Component({
    standalone: false,
    selector: 'particle-edit-report',
  templateUrl: './edit-report.component.html',
  styleUrls: ['./edit-report.component.scss']
})
export class EditReportComponent implements OnInit, OnDestroy {

  breadcrumbs: BreadcrumbModel[];
  private response$: Observable<any>;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private reportModel: any;
  private reportId: string;
  private queryModels: QueryModel[] = [];
  private queryKey = 'GenericReportById';
  apiEndpointKey = 'DataSurveyApi';
  workflowId: string;
  private workflowState$: Observable<IWorkflowState>;
  private cleanedUp$: Observable<string>;
  private action: string;
  private reportTaskId: string;
  constructor(private queryStore: Store<IQueryState>,
              protected activatedRoute: ActivatedRoute,
              private router: Router) {
    this.workflowId = Guid.create().toString();
  }

  ngOnInit() {
    this.queryModels.push(QueryProvider.getQuery(this.queryKey));
    this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => {
      this.reportId = params.reportId;
      this.action = params.action;
      this.reportTaskId = Guid.create().toString();
      this.response$ = this.queryStore.pipe(select(getQueryResponse, this.queryKey));
      this.response$.pipe(take(2)).subscribe(report => {
        if (report) {
          this.reportModel = report;
          const actionTitle = this.action === 'edit' ? 'Edit' : 'Add Task';
          this.breadcrumbs = [
            <BreadcrumbModel>{
              id: 'Case',
              title: 'DAC6 & MDR Reporter',
              type: 'Case',
              relativeUrl: 'dac6-reporter/overview'
            },
            <BreadcrumbModel>{
              id : 'Reports',
              title: 'Reports',
              type: 'Reports',
              relativeUrl: 'dac6-reporter/reports'
            },
            <BreadcrumbModel>{
              id : 'reportTitle',
              title: report.title,
              type: 'ReportTitle',
              relativeUrl: `dac6-reporter/reports/${report.id}`
            },
            <BreadcrumbModel>{
              id : `${this.action}`,
              title: `${actionTitle}`,
              type: `${this.action}`,
              relativeUrl: `dac6-reporter/reports/${report.id}/${this.action}`
            }
          ];
        }
        this.loadWorkflow();
      });
      QueryProvider.invokeQuery(this.queryStore, this.queryKey, {'[Id]': this.reportId});
    });
  }

  loadWorkflow() {
    if (!this.reportModel) {
      return;
    }
    const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId, 'Edit Report', 'edit-report-workflow', true);
    action.setParameters({
      'ReportId': this.reportId,
      'ReportTaskId': this.reportTaskId
    });
    this.queryStore.dispatch(action);
    this.workflowState$ = this.queryStore.pipe(select(getWorkflowReducerState, this.workflowId));
    this.workflowState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      console.log(state);
    });
    this.cleanedUp$ = this.queryStore.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if (state === 'Finished' || state === 'Cancelled') {
        this.router.navigateByUrl(`dac6-reporter/reports/${this.reportId}`);
      }
    });
  }

  onGridCellValueChange($event) {

  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.queryModels.forEach(c => {
      this.queryStore.dispatch(new DeleteQueryAction(c, null, null));
    });
  }
}
